import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { IoClose } from 'react-icons/io5';
import { toast } from 'react-toastify';
import { API } from '../config';

export default function RecoverPwd({ show, onClose }) {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (show) {
            setUsername('');
            setEmail('');
        }
    }, [show]);

    if (!show) return null;

  const handleSubmit = async e => {
    e.preventDefault();

      // Require BOTH fields since we match against stored recoveryEmail
      if (!username.trim() || !email.trim()) {
        return toast.error('Enter your Nickname and your recovery email.');
      }

    setSubmitting(true);
    try {
     await axios.post(`${API}/api/users/auth/forgot-password`, {
        username: username.trim(),
        email: email.trim().toLowerCase(),
      });
      toast.success('If that account exists, we sent a reset link.');
      onClose();
      // clear fields
        setUsername('');
        setEmail('');
    } catch (err) {
      // Still keep generic; don’t leak whether user/email exists
      toast.error('If that account exists, we sent a reset link.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className='change-password'>
        <div className="overlay">
              <form onSubmit={handleSubmit} className="pwd-form">
                <IoClose className="close-icon" onClick={onClose}/>
                <div className="form-input">
                      <label htmlFor="username">
                          Enter your username
                      </label>
                      <input
                        name='username'
                        type="text"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                        required
                      />
                </div>
                <div className="form-input">
                      <label htmlFor="email">
                          Enter your recovery email
                      </label>
                      <input
                        name='email'
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                      />
                </div>
                

                <button type="submit" className="btn" id='feedback-button' disabled={submitting}>
                    <span className="btn-text">{submitting ? 'Sending…' : 'Send Recover Link'}</span>
                </button>
              </form>
        </div>
    </section>

  );
}
